/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CustomPasswordReset
 */
export interface CustomPasswordReset {
  /**
   *
   * @type {string}
   * @memberof CustomPasswordReset
   */
  email: string;
}

/**
 * Check if a given object implements the CustomPasswordReset interface.
 */
export function instanceOfCustomPasswordReset(value: object): value is CustomPasswordReset {
  if (!('email' in value) || value['email'] === undefined) return false;
  return true;
}

export function CustomPasswordResetFromJSON(json: any): CustomPasswordReset {
  return CustomPasswordResetFromJSONTyped(json, false);
}

export function CustomPasswordResetFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomPasswordReset {
  if (json == null) {
    return json;
  }
  return {
    email: json['email'],
  };
}

export function CustomPasswordResetToJSON(value?: CustomPasswordReset | null): any {
  if (value == null) {
    return value;
  }
  return {
    email: value['email'],
  };
}
